export default "__VITE_ASSET__B7c5rje5__";